export default __webpack_public_path__ + "static/media/IMG-20241210-WA0044.0e356a55.jpg";